import {
  Default,
  DefaultSmall,
  DefaultXSmall,
  DefaultLarge,
  DefaultXLarge,
} from './components/default';
import { h1, h2, h3, h4, h5 } from './components/h';

export const Text = {
  h1,
  h2,
  h3,
  h4,
  h5,
  normal: Default,
  small: DefaultSmall,
  xsmall: DefaultXSmall,
  large: DefaultLarge,
  xlarge: DefaultXLarge,
};
